export default "__VITE_ASSET__Q7OMmG$n__"